import { useEffect } from "react";
import { merchantActive } from "../../../services/api/merchant/merchantApi";

const MERCHANT_ACTIVE = "kvw-merchant-active";
const DATE_TOTAL_TIME = 24 * 60 * 60 * 1000;

export const useMerchantActive = (
  merchantInfo: IRetailMerchantInfo | undefined,
  branchInfo: IRetailBranchInfo | undefined,
  autoActive = true
) => {
  const active = () => {
    if(localStorage){
      localStorage.setItem(
        MERCHANT_ACTIVE,
        JSON.stringify({
          firstTime: Date.now(),
          isTracked: true,
        })
      );
    }

    merchantActive(merchantInfo!.id, branchInfo!.id);
  };

  useEffect(() => {
    if (!merchantInfo || !branchInfo || !autoActive) {
      return;
    }

    const now = Date.now();
    const data = window.localStorage ? localStorage.getItem(MERCHANT_ACTIVE) : "";
    let activeInfo = data ? JSON.parse(data) : { firstTime: now };
    // Check đã active được 1 ngày thì reset
    const timeActive = now - activeInfo.firstTime;
    if (timeActive === 0 || timeActive > DATE_TOTAL_TIME) {
      activeInfo = { firstTime: now };
      if(localStorage){
        localStorage.setItem(MERCHANT_ACTIVE, JSON.stringify(activeInfo));
      }
    }

    // Trong ngày đã track thì bỏ qua
    if (activeInfo.isTracked) {
      return;
    }

    active();
  }, [merchantInfo, branchInfo]);

  return {
    active,
  };
};
